<template lang="pug">
	content-page(v-if="filterstring" pagenav-icon="tune" )
		div(slot="nav")
			areas-filter-list(v-model="filterstring")
			nuxt-link(:to="localePath('areas-countries')") {{$t('page.areas:navlist.countries')}}
		div
			h1 {{contentpage.name}}
			.infosheet.ml-4(style="float:right")
				v-card.mb-3(outlined color="info")
					v-img(:aspect-ratio="16/9" :src="`${contentpage.meta.image}?width=640`" :alt="contentpage.name")
					ws-content.pa-3(:markdown="infosheet" level="2")
			ws-content(:value="contentpage.content")
				v-row.hidden-xs-only(no-gutters)
					v-col.font-weight-bold.text-no-wrap {{$tc('area_list.total_{count}', total)}}
					v-spacer
					areas-sort(v-model="sort")
						li(field="RELEVANCE") {{$t('area_list.sorting.relevance')}}
						li(field="NAME" ascending) {{$t('area_list.sorting.name')}}
						li(field="PISTES") {{$t('area_list.sorting.pistes')}}
						li(field="SNOW") {{$t('area_list.sorting.snow')}}
						li(field="MAXELEVATION") {{$t('area_list.sorting.maxelevation')}}
						li(field="RATING") {{$t('area_list.sorting.rating')}}
						li(:field="`DISTANCE_${$store.getters.preferedCity.toUpperCase()}`" ascending) {{$t('area_list.sorting.distance_{city}', {city: $store.getters.preferedCity.charAt(0).toUpperCase() + $store.getters.preferedCity.slice(1)})}}
				v-divider
				areas-list(:filterstring="filterstring" :sort="sort" :total.sync="total")
	content-page(v-else)
		div(slot="nav")
			navigation-default
		div.hidden-sm-and-down(slot="sidebar")
			ad(location="sidebar").mb-6
			offers.mb-6
		.flow-left
			h1 {{contentpage.name}}
			ws-content(:value="contentpage.content")
</template>

<script>
import gql from 'graphql-tag';
import AreasList from '@/components/areas/list.vue';
import AreasSort from '@/components/areas/sort';
import AreasFilterList from '@/components/areas/filter-list.vue';
import { md } from '@dengl/common/utils/markdown-it.js';
import NavigationDefault from '@/components/navigation-default';

import Content from '@dengl/common/components/content.vue';
import MetaFragment from '@/components/graphql/metaFragment.graphql';
const areasIndexQuery = gql`
	query getAreasIndexWithPath($path: String!) {
		contentpage(path: $path) {
			id
			name
			slug
			content {
				...ContentDataFragment
			}
			parents {
				id
				name
				slug
				path
				isHiddenInMenu
			}
			...MetaFragment
		}
	}
	${MetaFragment}
	${Content.fragments}
`;

export default {
	nuxtI18n: {
		paths: {
			'nl-NL': '/skigebieden/thema/:theme',
			'de-DE': '/themen/skigebiete/:theme',
			'nl-BE': '/skigebieden/thema/:theme'
		}
	},
	components: {
		AreasList,
		AreasSort,
		NavigationDefault,
		'areas-filter-list': AreasFilterList
	},
	asyncData({ app, error, route }) {
		app.ads({});
		return app.$graphClient
			.query({
				query: areasIndexQuery,
				variables: {
					path: route.path
				},
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (!data.contentpage) {
					return error({ statusCode: 404, message: 'Page not found' });
				}

				if (errors) {
					throw errors[0];
				}

				app.meta(data.contentpage.meta);

				const crumbs = {};
				if (data.contentpage.content.embeds) {
					const areaListEmbed = data.contentpage.content.embeds.find(
						embed => embed.type === 'config-area-list'
					);

					if (areaListEmbed) {
						data.filterstring = areaListEmbed.data.filterstring;
						data.infosheet = md('ALL').render(areaListEmbed.data.infosheet);
					}
				}

				if (data.contentpage.parents) {
					[...data.contentpage.parents].reverse().forEach(parent => {
						if (!parent.isHiddenInMenu) {
							crumbs[parent.name] = {
								name: 'contentpage',
								params: { 0: parent.path.slice(1) }
							};
						}
					});
				}

				crumbs[data.contentpage.name] = {
					name: 'contentpage',
					params: { 0: route.path.slice(1) }
				};

				app.breadcrumbs(crumbs);

				return data;
			})
			.catch(error => {
				return app.httpError(500, null, 'areas-index-01', error);
			});
	},
	data() {
		return {
			filterstring: '',
			infosheet: null,
			sort: {
				ascending: false,
				field: 'RELEVANCE'
			},
			total: null
		};
	},
	head() {
		return {
			...this.$structuredData()
		};
	},
	// watch: {
	// 	'$route.hash': function() {
	// 		this.filterstringFromHash();
	// 	},
	// 	filterstring: function(val) {
	// 		window.location.hash = `#${val}`;
	// 	}
	// },
	// mounted() {
	// 	this.filterstringFromHash();
	// },
	methods: {
		filterstringFromHash() {
			if (this.$route.hash) {
				this.filterstring = this.$route.hash.slice(1);
			}
		}
	}
};
</script>
